import { createContext, useState, useCallback } from "react";

export const LayoutContext = createContext(null);

export default function LayoutContextProvider({ children }) {
  const [layout, setLayout] = useState({
    header: true,
    sidebar: false,
    issues: true,
    toolbar: false,
  });

  const wrappedSetLayout = useCallback((newLayout) => {
    setLayout(newLayout);
  }, []);


  return (
    <LayoutContext.Provider value={{ layout, setLayout: wrappedSetLayout }}>
      {children}
    </LayoutContext.Provider>
  );
}
